import { setStorageJsonValue, SUPERSTORE_NAMESPACES, SUPERSTORE_STORAGE_ITEMS, SUPERSTORE_STORAGE_KEYS } from '../../../utils/superStoreUtils';
export const deleteLastSubscriptionTime = () => {
  return setStorageJsonValue({
    namespace: SUPERSTORE_NAMESPACES.NOTIFICATION,
    storageKey: SUPERSTORE_STORAGE_KEYS.BROWSER,
    storageItem: SUPERSTORE_STORAGE_ITEMS.LAST_PUSH_SUBSCRIBE_TIME,
    value: undefined
  });
};